import { Box } from "@mui/system";
import ConfigRoteiros from "./configRoteiros";
import ConfigSuporte from "./configSuporte";

import ConfigOpenTicketCliente from "./configOpenTicketCliente";
import ConfigTickets from "./configTickets";
import Formularios from "../../../6.0-suporte/formularios";
import ConfigRfo from "./configRfo";
import ConfigOpenTicket from "./configOpenTicket";

export default function Suporte() {
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
  return (
    <Box sx={{ mt: "15px" }}>
      {(erp === "HUBSOFT" || erp === "IXC") && <ConfigSuporte />}

      {erp === "HUBSOFT" && (
        <>
          <ConfigOpenTicketCliente />
          <ConfigOpenTicket />
          <ConfigRfo />
        </>
      )}
      <ConfigTickets />
      <ConfigRoteiros />
      <Formularios />
    </Box>
  );
}
